var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1566,
    height: 1378,
    viewBox: "0 0 1566 1378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.757 1145.91C579.931 1386.15 1064.59 1433.93 1285.83 1314.41C1493.42 1202.27 1517.62 1003.72 1396.33 804.625C1235.46 540.596 1398.82 334.512 1228.28 132.238C1112.86 -4.63598 663.595 -77.307 324.915 127.906C-8.71861 330.055 -173.055 806.661 267.779 1145.92L267.757 1145.91Z",
    fill: "#EADEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M875.673 1301.58C595.317 1287.38 381.145 1070.15 379.437 886.159C377.836 713.551 503.712 582.063 684.539 524.107C924.326 447.262 1003.22 240.671 1204.61 205.786C1340.94 182.179 1558.76 366.502 1546.21 661.567C1533.95 952.201 1271.61 1321.66 875.673 1301.58Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M971.781 1309.12C687.417 1348.71 442.651 1191.72 416.376 1025.05C391.716 868.689 501.021 725.833 675.444 639.41C906.784 524.774 958.613 322.545 1156.92 253.171C1291.12 206.242 1535.19 332.705 1561.95 602.803C1588.33 868.802 1373.29 1253.17 971.781 1309.12Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack1);
export default __webpack_public_path__ + "static/media/back1.ebfb9fec6a99477c2f1786ae410ceb66.svg";
export { ForwardRef as ReactComponent };